import User from "@views/user/User";

export default [
  {
    path: "/user",
    name: "User",
    meta: {
      title: "Account",
      keepAlive: true,
      footer: true
      // auth: true
    },
    component: User
  },
  {
    path: "/user/binding",
    name: "BindingPhone",
    meta: {
      title: "Link phone number",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/BindingPhone.vue")
  },
  {
    path: "/user/add_address/:id?",
    name: "AddAddress",
    meta: {
      title: "添加收货地址",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddAddress.vue")
  },
  {
    path: "/user/account",
    name: "UserAccount",
    meta: {
      title: "My account",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserAccount.vue")
  },
  {
    path: "/user/add_manage",
    name: "AddressManagement",
    meta: {
      title: "地址管理",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddressManagement.vue")
  },
  {
    path: "/user/poster",
    name: "Poster",
    meta: {
      title: "Distribution poster",
      keepAlive: false,
      backgroundColor: "#a3a3a3",
      auth: true
    },
    component: () => import("@views/user/promotion/Poster.vue")
  },
  {
    path: "/user/sign",
    name: "Sign",
    meta: {
      title: "Sign",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Sign.vue")
  },
  {
    path: "/user/sign_record",
    name: "SignRecord",
    meta: {
      title: "Sign in history",
      keepAlive: true
    },
    component: () => import("@views/user/signIn/SignRecord.vue")
  },
  {
    path: "/user/cash",
    name: "UserCash",
    meta: {
      title: "Cash withdrawal",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/user/audit",
    name: "CashAudit",
    meta: {
      title: "Verify withdrawal",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashAudit.vue")
  },
  {
    path: "/user/promoter_order",
    name: "PromoterOrder",
    meta: {
      title: "Promoter orders",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterOrder.vue")
  },
  {
    path: "/user/promoter_list",
    name: "PromoterList",
    meta: {
      title: "Promoter list",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterList.vue")
  },
  {
    path: "/user/user_promotion",
    name: "UserPromotion",
    meta: {
      title: "Promoter management",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserPromotion.vue")
  },
  {
    path: "/user/user_promotion_info",
    name: "user_promotion_info",
    meta: {
      title: "I want to promote",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/Info.vue")
  },
  {
    path: "/user/bill/:types?",
    name: "UserBill",
    meta: {
      title: "Account details",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserBill.vue")
  },
  {
    path: "/user/cashrecord",
    name: "CashRecord",
    meta: {
      title: "Commission withdrawal record",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashRecord.vue")
  },
  {
    path: "/user/commission",
    name: "CommissionDetails",
    meta: {
      title: "Commission details",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionDetails.vue")
  },
  {
    path: "/user/integral",
    name: "Integral",
    meta: {
      title: "Detalis of points",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Integral.vue")
  },
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "Member center",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserVip.vue")
  },
  {
    path: "/user/data",
    name: "PersonalData",
    meta: {
      title: "User profile",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/PersonalData.vue")
  },
  {
    path: "/user/user_coupon",
    name: "UserCoupon",
    meta: {
      title: "My coupons",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/coupon/UserCoupon.vue")
  },
  {
    path: "/user/get_coupon",
    name: "GetCoupon",
    meta: {
      title: "Get coupons",
      keepAlive: true
    },
    component: () => import("@views/user/coupon/GetCoupon.vue")
  },
  {
    path: "/user/user_cash",
    name: "UserCash",
    meta: {
      title: "Commission withdrawal",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/user/user_cash_public",
    name: "UserCashPublic",
    meta: {
      title: "Apply withdrawal",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCashPublic.vue")
  },
  {
    path: "/customer/list",
    name: "CustomerList",
    meta: {
      title: "Customer service",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/CustomerList.vue")
  },
  {
    path: "/user/Recharge",
    name: "Recharge",
    meta: {
      title: "Balance deposit",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/Recharge_cash.vue")
  },
  {
    path: "/user/Recharge_channel",
    name: "Recharge_channel",
    meta: {
      title: "Recharg channel",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/rechargeCashSelect.vue")
  },
  {
    path: "/user/Recharge_info",
    name: "Recharge_info",
    meta: {
      title: "Recharge info",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/rechargeMethod.vue")
  },
  {
    path: "/user/cashHelp",
    name: "cashHelp",
    meta: {
      title: "Help",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/cashHelp.vue")
  },
  {
    path: "/user/Recharge_cash",
    name: "Recharge_cash",
    meta: {
      title: "Deposit application",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/Recharge_cash.vue")
  },
  {
    path: "/user/Recharge_cash_info",
    name: "Recharge_cash_info",
    meta: {
      title: "Confirm deposit details",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/Recharge_cash_info.vue")
  },
  {
    path: "/user/myPay",
    name: "myPay",
    meta: {
      title: "Bind deposit channel",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/myPay.vue")
  },
  {
    path: "/user/removeMyPay",
    name: "removeMyPay",
    meta: {
      title: "Unbind deposit channel",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/removeMyPay.vue")
  },
  {
    path: "/user/promoter_rank",
    name: "PromoterRank",
    meta: {
      title: "Promoter ranking",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterRank.vue")
  },
  {
    path: "/user/commission/rank",
    name: "CommissionRank",
    meta: {
      title: "Commission ranking",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionRank.vue")
  },
  {
    path: "/user/usermessages",
    name: "userMessages",
    meta: {
      title: "Notice",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/messages/userMessagaes.vue")
  },
  {
    path: "/user/readme",
    name: "userMessages",
    meta: {
      title: "About us",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/messages/readme.vue")
  },
  {
    path: "/user/game_list",
    name: "game_list",
    meta: {
      title: "List of games",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/gameList.vue")
  },
  {
    path: "/user/rank",
    name: "rank",
    meta: {
      title: "Draw history",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/rank.vue")
  },
  {
    path: "/user/bank",
    name: "bank",
    meta: {
      title: "Deposit",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/bank/bank.vue")
  },
  {
    path: "/user/bank/recharge",
    name: "bankRecharge",
    meta: {
      title: "Deposit & withdrawals",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/bank/Recharge.vue")
  },
  {
    path: "/user/bank/log",
    name: "bankLog",
    meta: {
      title: "Account details",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/bank/log.vue")
  },
  {
    path: "/user/serve/msgList",
    name: "serveMsgList",
    meta: {
      title: "Messages List",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/serve/msgList.vue")
  },
  {
    path: "/user/serve/report",
    name: "serveReport",
    meta: {
      title: "Submit message",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/serve/report.vue")
  },
  {
    path: "/user/serve/details",
    name: "serveReport",
    meta: {
      title: "Message of details",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/serve/details.vue")
  },
  {
    path: "/user/agent",
    name: "agent",
    meta: {
      title: "Apply for the agent",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/agent.vue")
  },
  {
    path: "/user/pay",
    name: "IMPAID",
    meta: {
      title: "IMPAID",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/pay.vue")
  }
];
